<template>
  <div v-if="invitation">
    <!-- Header -->
    <div class="header bg-gradient-success py-7 py-lg-8 pt-lg-9">
      <div class="container">
        <div class="header-body text-center mb-7">
          <div class="row justify-content-center">
            <div class="col-xl-5 col-lg-6 col-md-8 px-5">
              <div class="logo-center text-center pb-4">
                <!-- <img src="img/brand/white.png"> -->
                <!-- <img
                    class="icon-logo"
                    src="@/assets/img/brand/logo-black.svg"
                  /> -->
                
              </div>
              <h1 class="text-white">
                Hello {{ invitation.invitedTo.firstName }}
                {{ invitation.invitedTo.lastName }}
              </h1>
              <p class="text-lead text-white">
                {{ invitation.invitedBy.firstName }}
                {{ invitation.invitedBy.lastName }} has invited you to Join
                <br />
              </p>

              <h3 class="text-white">
                <strong>{{
                  invitation.parent ? invitation.parent.name + " / " : ""
                }}</strong>
                <strong>{{ invitation.project.name }}</strong>
              </h3>
            </div>
          </div>
        </div>
      </div>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg
          x="0"
          y="0"
          viewBox="0 0 2560 100"
          preserveAspectRatio="none"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polygon class="fill-default" points="2560 0 2560 100 0 100" />
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <div class="container mt--8 pb-5">
      <!-- Table -->
      <div class="row justify-content-center">
        <div class="col-lg-6 col-md-8">
          <div class="w-100 h-100 flex-box bg-secondary">
            <div class="card bg_disabled">
              <div
                class="card-header bg-transparent border-0 align-items-stretch w-100"
              ></div>
              <div class="card-body">
                <div class="text-center">
                  <p><b>We need few details to create your account</b></p>
                </div>
                <form role="form">
                  <base-input
                    v-model="firstname"
                    alternative
                    class="mb-3"
                    prepend-icon="ni ni-single-02"
                    placeholder="First Name"
                  />
                  <div v-if="$v.firstname.$error" class="error field">
                    First Name is required
                  </div>
                  <base-input
                    v-model="lastname"
                    alternative
                    class="mb-3"
                    prepend-icon="ni ni-single-02"
                    placeholder="Last Name"
                  />
                  <div v-if="$v.lastname.$error" class="error field">
                    Last Name is required
                  </div>
                  <base-input
                    v-model="email"
                    alternative
                    class="mb-3"
                    prepend-icon="ni ni-email-83"
                    placeholder="Email"
                  />
                  <div v-if="$v.email.$error" class="error field">
                    Valid email is required
                  </div>
                  <base-input
                    v-model="password"
                    alternative
                    class="mb-3"
                    prepend-icon="ni ni-lock-circle-open"
                    type="password"
                    placeholder="Password"
                  />
                  <div v-if="$v.password.$error" class="error field">
                    Password is required
                  </div>
                  <base-input
                    v-model="confirm"
                    alternative
                    class="mb-3"
                    prepend-icon="ni ni-lock-circle-open"
                    type="password"
                    placeholder="Confirm Password"
                  />
                  <div v-if="$v.confirm.$required == false" class="error field">
                    Confirm password is required
                  </div>
                  <div
                    v-if="$v.confirm.sameAsPassword == false"
                    class="error field"
                  >
                    Confirm should match with password
                  </div>

                  <div class="text-center">
                    <base-button
                      type="primary"
                      class="my-4 btn-block"
                      @click="handleRegistration"
                      >Complete</base-button
                    >
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import {
  required,
  minLength,
  between,
  email,
  sameAs
} from "vuelidate/lib/validators";
export default {
  name: "Invite",
  data() {
    return {
      firstname: "",
      lastname: "",
      email: "",
      password: "",
      confirm: "",
      invitation: null
    };
  },
  validations: {
    firstname: {
      required
    },
    lastname: {
      required
    },
    email: {
      email,
      required,
      minLength: minLength(4)
    },
    password: {
      required
    },
    confirm: {
      required,
      sameAsPassword: sameAs("password")
    }
  },

  created() {
    if (this.$route.params.invitation) {
      this.invitation = this.$route.params.invitation;
      this.firstname = this.invitation.invitedTo.firstName;
      this.lastname = this.invitation.invitedTo.lastName;
      this.email = this.invitation.invitedTo.email;
    }
  },

  mounted() {},

  methods: {
    ...mapMutations(["setLoading"]),
    ...mapMutations("user", ["setRegistrationData"]),
    ...mapActions("user", [
      "performUserRegistration",
      "completeRegistration",
      "fetchUserInfoAction"
    ]),
    async handleRegistration() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      // this.performLoginPassword({username:this.email, password:this.password}).then(r => {
      //    this.$router.push('/projects')
      // }).catch(err => {
      //     this.$snack.success('Invalid Credentials.')
      // })

      try {
        this.setLoading(true);
        let r = await this.completeRegistration({
          first_name: this.firstname,
          last_name: this.lastname,
          password: this.password,
          password_confirmation: this.confirm,
          email: this.email,
          id: this.invitation.invitedTo.id,
          role_id: 4 //user
        });
        await this.fetchUserInfoAction();
        let { id, name } = this.invitation.parent
          ? this.invitation.parent
          : this.invitation.project;
        this.$router.push({
          name: "tasks.home",
          params: {
            id: id,
            name: name,
            showThread: this.invitation.parent ? true : false,
            threadId: this.invitation.project.id
          }
        });
      } catch (e) {
        if (e.response.status == 400) {
          this.$snack.success(
            e.response.data.message[Object.keys(e.response.data.message)[0]][0]
          );
        }

        this.setLoading(false);
      }
    }
  }
};
</script>

<style lang="sass"></style>
